import {
  AddClassPostCommentMutation,
  AddClassPostCommentMutationVariables,
  DeleteClassPostCommentMutation,
  DeleteClassPostCommentMutationVariables,
} from "@outschool/gql-frontend-generated";
import { useMutation } from "@outschool/ui-apollo";
import {
  AddClassPostCommentInput,
  addClassPostCommentMutation,
  deleteClassPostCommentMutation,
} from "@outschool/ui-components-classroom";
import React from "react";

import { useCurrentLearner } from "../providers/CurrentLearnerProvider";

export type AssignmentPublicCommentSubmitInput = Parameters<
  React.ComponentProps<typeof AddClassPostCommentInput>["onSubmit"]
>[0];

export function useAssignmentPublicCommentActions({
  assignmentClassPostUid,
  onChanged,
}: {
  assignmentClassPostUid: string;
  onChanged: () => unknown;
}) {
  const currentLearner = useCurrentLearner();
  const [error, setError] = React.useState<unknown>(null);
  const [addComment] = useMutation<
    AddClassPostCommentMutation,
    AddClassPostCommentMutationVariables
  >(addClassPostCommentMutation);
  const [deleteComment] = useMutation<
    DeleteClassPostCommentMutation,
    DeleteClassPostCommentMutationVariables
  >(deleteClassPostCommentMutation);

  const submitComment = async ({
    text,
    attachments,
    video,
  }: AssignmentPublicCommentSubmitInput) => {
    setError(null);
    try {
      await addComment({
        variables: {
          classPostCommentInput: {
            assignmentClassPostUid,
            learnerUid: currentLearner?.uid,
            messageContent: {
              text,
              attachmentUids: attachments?.map(a => a.uid) ?? [],
              videoUid: video?.uid,
            },
          },
          plainText: false,
        },
      });
      await onChanged();
    } catch (err) {
      setError(err);
      throw err;
    }
  };

  const removeComment = async (commentUid: string) => {
    await deleteComment({ variables: { classPostCommentUid: commentUid } });
    await onChanged();
  };

  return { error, submitComment, removeComment };
}
